<template>
  <div class="container">
    <div class="img-list" >
      <img class="img" v-for="(img, i) in imgList" :key="i" :src="img">
    </div>
    <div :class="['footer-btn', type]">
      <img class="footer-img" :src="buttonImg" @click="openWeapp(type)">
    </div>
    <div v-if="showModal" class="modal-container">
      <div class="modal">
        <div class="modal-close" @click="showModal = false"></div>
        <div class="modal-desc">长按识别下方二维码，添加小助手</div>
        <img class="qrCode" :src="qrCodeUrl" />
      </div>
    </div>
  </div>
</template>

<script>
import list from './data'
import { getEduAppVersion, isBiggerThanSpecifiedVersion } from '../../../uitl/getVersion';
export default {
  name: "InterviewCardH5",
  data() {
    return {
      list,
      page_id: '',
      type: '',
      imgList: [],
      footerImg: '',
      btnName: '',
      qrCodeUrl: '',
      isAndroid: navigator.userAgent.indexOf('Android') !== -1,
      showModal: false
    };
  },
  mounted() {
    this.type = this.$route.query.type || 'offer';
    this.imgList = this.list[this.type].imgList;
    this.buttonImg = this.list[this.type].buttonImg;
    this.page_id = this.list[this.type].pageId;
    this.btnName = this.list[this.type].buttonName;
    this.qrCodeUrl = this.list[this.type].qrCodeUrl;
    this.eduPlatTrack('WebView', {
      page_id: this.page_id
    });
  },
  methods: {
    openWeapp(type) {
      this.eduPlatTrack('WebButtonClick', {
        page_id: this.page_id,
        'button_name': this.btnName
      });
      if (!this.isApp) {
        this.showModal = true;
        return;
      }
      /**
       * from
       *    测试: 0   产品: 1   前端: 2   JAVA: 3   数分: 4   运营: 5   综合: 6
       * miniProgramType
       *    IOS: 1 小程序正式版  2 开发版  3 体验版
       *    安卓: 0 小程序正式版  1 开发版  2 体验版
       */
      const path = `/pages/community/index.html?type=${type}`;
      const userName = 'gh_5bc6c955d1db';
      const miniProgramType = this.isAndroid ? 0 : 1;
      const locationPath = encodeURIComponent(path);
      if (this.isEduApp) {
        const version = isBiggerThanSpecifiedVersion(getEduAppVersion(), '2.3.2');
        const bridgeTitle = this.isAndroid ? version ? 'lgedu' : 'lgeduapp' : 'lgedu';
        const bridgeUrl = `${bridgeTitle}://lgedu.com/miniProgram?userName=${userName}&path=${locationPath}&miniProgramType=${miniProgramType}`;
        window.location = bridgeUrl;
      } else if (this.isLgApp) {
        const lgBridgeTitle = this.isAndroid ? 'lagouapp' : 'lagou';
        const lgPath = this.isAndroid ? path : locationPath;
        const lgBridgeUrl = `${lgBridgeTitle}://lagou.com/miniProgram?userName=${userName}&path=${lgPath}&miniProgramType=${miniProgramType}`;
        window.location = lgBridgeUrl;
      }
    }
  },
};
</script>
<style lang='less' scoped>
.container {
  position: relative;
  width: 100%;
  min-height: 100vh;
  overflow-y: auto;
  // padding-bottom: 165px;
}
.img-list {
  width: 100%;
  display: flex;
  flex-wrap: wrap;
}
.img {
  width: 100%;
}
.footer-btn {
  position: fixed;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 165px;
  box-sizing: border-box;
  &.offer {
    background-color: #fff;
    padding: 0 45px 67px 63px;
  }
  &.operate {
    background-color: #0B0B0B;
    padding: 0 45px 67px 63px;
  }
  &.byte {
    background-color: #E9EAF3;
    padding: 0 14px 49px 14px;
    .footer-img {
      width: 100%;
      height: 127px;
    }
  }
  .footer-img {
    width: 100%;
    height: 98px;
  }
}
.modal-container {
  position: fixed;
  z-index: 9999;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, .5);
  .modal {
    position: absolute;
    top: 40%;
    left: 50%;
    width: 600px;
    background-color: #fff;
    border-radius: 8px;
    transform: translate(-50%, -50%);
    padding: 60px;
    box-sizing: border-box;
    .modal-header {
      display: flex;
      width: 180px;
      height: 40px;
      line-height: 40px;
      margin: 0 auto;
      font-size: 32px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: bold;
      color: #333333;
      justify-content: space-between;
      align-items: center;
      .modal-header-img {
        width: 40px;
        height: 40px;
      }
    }
    .modal-desc {
      height: 40px;
      font-size: 28px;
      font-family: PingFangSC-Regular, PingFang SC;
      color: #666666;
      line-height: 40px;
      text-align: center;
      margin-top: 23px;
    }
    .qrCode {
      display: block;
      width: 350px;
      height: 350px;
      margin: 49px auto 0;
    }
    .modal-btn {
      height: 88px;
      line-height: 88px;
      background: #00B38A;
      border-radius: 4px;
      font-size: 36px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: bold;
      color: #FFFFFF;
      text-align: center;
      margin-top: 42px;
    }
    .modal-close {
      width: 60px;
      height: 60px;
      position: absolute;
      left: 50%;
      bottom: -130px;
      border-radius: 50%;
      z-index: 10000;
      background: url("../assets/icon_delect@2x.png") no-repeat center;
      background-size: 100%;
      transform: translateX(-50%);
    }
  }
}
</style>
